import * as React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';

import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useThemeProps } from '@mui/material/styles';
export default function ClosableDialogTitle(props) {
  const {
    children,
    onClose,
    position = 'right',
    icon: iconControlled,
    ...other
  } = useThemeProps({
    props: props,
    name: 'ClosableDialogTitle',
  });

  const Icon = React.useMemo(() => {
    if (iconControlled) return iconControlled;

    if (position === 'right') {
      return CloseIcon;
    }

    if (position === 'left') {
      return ArrowBackIcon;
    }
  }, [iconControlled, position]);

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={
            position === 'right'
              ? {
                  zIndex: 2,
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }
              : {
                  zIndex: 2,
                  position: 'absolute',
                  left: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }
          }
        >
          <Icon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

ClosableDialogTitle.propTypes = {
  icon: PropTypes.elementType,
  position: PropTypes.oneOf(['left', 'right']),
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  other: PropTypes.object, // Pass through any other props to the DialogTitle component.
};
